import React from "react";
import { motion } from "framer-motion";

import transactionalImg from "../../../../Assets/Images/whatsapp/payment_sms.png";
import promotionalImg from "../../../../Assets/Images/whatsapp/Promotional_sms.png";
import bulkApiImg from "../../../../Assets/Images/whatsapp/sms-api.png";

export default function FeatureSection() {
  return (
    <section
      className="
        relative
        pt-10
        pb-10
        overflow-hidden
        font-saira
      "
      style={{
        backgroundColor: "var(--bg-primary)",
      }}
    >
      {/* ============================================================
          BACKGROUND GLOW
      ============================================================ */}

      <div
        className="
          absolute
          left-1/2
          top-0
          h-[420px]
          w-[420px]
          -translate-x-1/2
          rounded-full
          blur-[170px]
        "
        style={{
          backgroundColor: "color-mix(in srgb, var(--brand-primary) 10%, transparent)",
        }}
      />

      <div
        className="
          absolute
          -left-20
          bottom-0
          h-80
          w-80
          rounded-full
          blur-[150px]
        "
        style={{
          backgroundColor: "color-mix(in srgb, var(--brand-primary) 5%, transparent)",
        }}
      />

      <div
        className="
          absolute
          -right-20
          top-10
          h-80
          w-80
          rounded-full
          blur-[150px]
        "
        style={{
          backgroundColor: "color-mix(in srgb, var(--brand-primary) 5%, transparent)",
        }}
      />

      <div
        className="
          relative
          mx-auto
          max-w-7xl
          px-6
          lg:px-8
        "
      >
        {/* ============================================================
            HEADING
        ============================================================ */}

        <motion.div
          initial={{
            opacity: 0,
            y: 35,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          viewport={{
            once: true,
          }}
          transition={{
            duration: 0.6,
          }}
          className="
            mx-auto
            max-w-3xl
            text-center
          "
        >
          <span
            className="
              text-sm
              font-semibold
              uppercase
              tracking-[4px]
            "
            style={{
              color: "var(--brand-light)",
            }}
          >
            SMS & OTP Features
          </span>

          <h2
            className="
              mt-4
              text-4xl
              font-bold
              leading-tight
              lg:text-5xl
            "
            style={{
              color: "var(--text-primary)",
            }}
          >
            Everything You Need

            <br />

            <span
              style={{
                color: "var(--brand-primary)",
              }}
            >
              In One Messaging Platform
            </span>
          </h2>

          <p
            className="
              mx-auto
              mt-5
              max-w-3xl
              text-xl
              leading-7
            "
            style={{
              color: "var(--text-muted)",
            }}
          >
            Streamline business communication with secure transactional
            messaging, targeted promotional campaigns, and powerful SMS API
            integrations.
          </p>
        </motion.div>

        {/* ============================================================
            BRANCH CONNECTOR
        ============================================================ */}

        <div
          className="
            relative
            mt-8
            hidden
            lg:block
          "
        >
          {/* Top Dot */}

          <div
            className="
              mx-auto
              h-5
              w-5
              rounded-full
            "
            style={{
              backgroundColor: "var(--brand-primary)",
              boxShadow:
                "0 0 20px color-mix(in srgb, var(--brand-primary) 80%, transparent)",
            }}
          />

          {/* Vertical Line */}

          <div
            className="
              mx-auto
              h-14
              w-[2px]
            "
            style={{
              background:
                "linear-gradient(to bottom, var(--brand-primary), color-mix(in srgb, var(--brand-primary) 20%, transparent))",
            }}
          />

          {/* Horizontal Line */}

          <div
            className="
              relative
              mx-auto
              max-w-6xl
            "
          >
            <div
              className="
                h-[2px]
                w-full
              "
              style={{
                background:
                  "linear-gradient(to right, transparent, color-mix(in srgb, var(--brand-primary) 30%, transparent), transparent)",
              }}
            />

            <div
              className="
                absolute
                left-[16.66%]
                top-0
                h-12
                w-[2px]
              "
              style={{
                backgroundColor:
                  "color-mix(in srgb, var(--brand-primary) 30%, transparent)",
              }}
            />

            <div
              className="
                absolute
                left-1/2
                top-0
                h-12
                w-[2px]
                -translate-x-1/2
              "
              style={{
                backgroundColor:
                  "color-mix(in srgb, var(--brand-primary) 30%, transparent)",
              }}
            />

            <div
              className="
                absolute
                right-[16.66%]
                top-0
                h-12
                w-[2px]
              "
              style={{
                backgroundColor:
                  "color-mix(in srgb, var(--brand-primary) 30%, transparent)",
              }}
            />
          </div>
        </div>

        {/* ============================================================
            CARDS
        ============================================================ */}

        <div
          className="
            mt-12
            grid
            items-stretch
            gap-8
            lg:grid-cols-3
          "
        >
          {/* ==========================================================
              TRANSACTIONAL SMS
          ========================================================== */}

          <motion.div
            initial={{
              opacity: 0,
              y: 50,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            viewport={{
              once: true,
            }}
            transition={{
              duration: 0.6,
            }}
            className="relative"
          >
            {/* Connector */}

            <div
              className="
                absolute
                -top-12
                left-1/2
                hidden
                h-12
                w-[2px]
                -translate-x-1/2
                lg:block
              "
              style={{
                backgroundColor:
                  "color-mix(in srgb, var(--brand-primary) 30%, transparent)",
              }}
            />

            <div
              className="
                flex
                h-full
                flex-col
                rounded-[30px]
                p-6
                transition-all
                duration-500
                hover:-translate-y-2
                hover:shadow-[0_25px_60px_rgba(249,115,22,.12)]
              "
              style={{
                backgroundColor: "var(--card-bg)",
                border: "1px solid var(--border-primary)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor =
                  "color-mix(in srgb, var(--brand-primary) 40%, transparent)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor =
                  "var(--border-primary)";
              }}
            >
              <div
                className="
                  overflow-hidden
                  rounded-[22px]
                "
                style={{
                  border: "1px solid var(--border-primary)",
                }}
              >
                <img
                  src={transactionalImg}
                  alt="Transactional SMS"
                  className="
                    h-[250px]
                    w-full
                    object-cover
                  "
                />
              </div>

              <div
                className="
                  mt-6
                  flex-1
                  text-center
                "
              >
                <h3
                  className="
                    text-2xl
                    font-semibold
                  "
                  style={{
                    color: "var(--text-primary)",
                  }}
                >
                  Transactional SMS
                </h3>

                <p
                  className="
                    mt-4
                    leading-7
                  "
                  style={{
                    color: "var(--text-muted)",
                  }}
                >
                  Deliver OTPs, payment alerts and critical notifications
                  instantly with secure, enterprise-grade messaging.
                </p>
              </div>
            </div>
          </motion.div>

          {/* ==========================================================
              PROMOTIONAL SMS
          ========================================================== */}

          <motion.div
            initial={{
              opacity: 0,
              y: 50,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            viewport={{
              once: true,
            }}
            transition={{
              duration: 0.6,
              delay: 0.15,
            }}
            className="relative"
          >
            {/* Connector */}

            <div
              className="
                absolute
                -top-12
                left-1/2
                hidden
                h-12
                w-[2px]
                -translate-x-1/2
                lg:block
              "
              style={{
                backgroundColor:
                  "color-mix(in srgb, var(--brand-primary) 30%, transparent)",
              }}
            />

            <div
              className="
                flex
                h-full
                flex-col
                rounded-[30px]
                p-6
                transition-all
                duration-500
                hover:-translate-y-2
                hover:shadow-[0_25px_60px_rgba(249,115,22,.12)]
              "
              style={{
                backgroundColor: "var(--card-bg)",
                border: "1px solid var(--border-primary)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor =
                  "color-mix(in srgb, var(--brand-primary) 40%, transparent)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor =
                  "var(--border-primary)";
              }}
            >
              <div
                className="
                  overflow-hidden
                  rounded-[22px]
                "
                style={{
                  border: "1px solid var(--border-primary)",
                }}
              >
                <img
                  src={promotionalImg}
                  alt="Promotional SMS"
                  className="
                    h-[250px]
                    w-full
                  "
                />
              </div>

              <div
                className="
                  mt-6
                  flex-1
                  text-center
                "
              >
                <h3
                  className="
                    text-2xl
                    font-semibold
                  "
                  style={{
                    color: "var(--text-primary)",
                  }}
                >
                  Promotional SMS
                </h3>

                <p
                  className="
                    mt-4
                    leading-7
                  "
                  style={{
                    color: "var(--text-muted)",
                  }}
                >
                  Launch targeted campaigns, exclusive offers and promotional
                  messages to engage customers and increase conversions.
                </p>
              </div>
            </div>
          </motion.div>

          {/* ==========================================================
              SMS API
          ========================================================== */}

          <motion.div
            initial={{
              opacity: 0,
              y: 50,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            viewport={{
              once: true,
            }}
            transition={{
              duration: 0.6,
              delay: 0.3,
            }}
            className="relative"
          >
            {/* Connector */}

            <div
              className="
                absolute
                -top-12
                left-1/2
                hidden
                h-12
                w-[2px]
                -translate-x-1/2
                lg:block
              "
              style={{
                backgroundColor:
                  "color-mix(in srgb, var(--brand-primary) 30%, transparent)",
              }}
            />

            <div
              className="
                flex
                h-full
                flex-col
                rounded-[30px]
                p-6
                transition-all
                duration-500
                hover:-translate-y-2
                hover:shadow-[0_25px_60px_rgba(249,115,22,.12)]
              "
              style={{
                backgroundColor: "var(--card-bg)",
                border: "1px solid var(--border-primary)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor =
                  "color-mix(in srgb, var(--brand-primary) 40%, transparent)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor =
                  "var(--border-primary)";
              }}
            >
              <div
                className="
                  overflow-hidden
                  rounded-[22px]
                "
                style={{
                  border: "1px solid var(--border-primary)",
                }}
              >
                <img
                  src={bulkApiImg}
                  alt="SMS API"
                  className="
                    h-[250px]
                    w-full
                  "
                />
              </div>

              <div
                className="
                  mt-6
                  flex-1
                  text-center
                "
              >
                <h3
                  className="
                    text-2xl
                    font-semibold
                  "
                  style={{
                    color: "var(--text-primary)",
                  }}
                >
                  SMS API
                </h3>

                <p
                  className="
                    mt-4
                    leading-7
                  "
                  style={{
                    color: "var(--text-muted)",
                  }}
                >
                  Integrate secure messaging into your CRM, ERP, website or
                  applications with fast, scalable REST APIs.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}